import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  featureImage: {
    width: "100vw",
    height: "100vh",
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "block",
  },
  text: {
    width: "80%",
  },
  footerOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    pointerEvents: "none",
  },
  content: {
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    background:
      "linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.60) 26.5%, rgba(0,0,0,0.50) 100%)",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: `0 ${theme.spacing.space16}px`,
    paddingBottom: theme.spacing.space24,
  },
  icons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
  icon: {
    padding: `${theme.spacing.space8}px 0px`,
  },
  games: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    background: "rgba(0,0,0,0.01)",
    backdropFilter: "blur(18px)",
    scrollSnapType: "x mandatory",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  gamesContent: {
    display: "flex",
    gap: theme.spacing.space16,
  },
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing.space16,
    pointerEvents: "auto",
  },
  headerRight: {
    display: "flex",
    gap: theme.spacing.space8,
  },
  logo: {
    padding: theme.spacing.space4,
    height: theme.spacing.space32,
  },
  footerNav: {
    pointerEvents: "auto",
    position: "sticky",
    bottom: 0,
    height: 72,
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100vw",
    background: "rgba(255,255,255,0.10)",
    backdropFilter: "blur(5px)",
  },
  item: {
    background: "unset",
    border: "unset",
    position: "relative",
    minWidth: 50,
  },
  active: {
    background: theme.colors.Primary,
    height: 80,
    zIndex: -1,
    position: "absolute",
    width: 64,
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
  },
  titleFooter: {
    fontSize: "10px !important",
    lineHeight: "16px",
    fontWeight: "700 !important",
  },
  img: {
    width: 120,
    height: 160,
    borderRadius: theme.radius.medium,
    flex: "0 0 auto",
  },
}));
